module.exports = "/images/Ropes Course.svg?c8e446e884fca51c19de05d3c7f76535";